import styled from "styled-components";
import { CircularProgress as MuiCircularProgress } from "@material-ui/core";

export const CircularProgress = styled(MuiCircularProgress)`
  && {
    color: ${props => props.theme.palette.primary.darker};
  }
`;